import type { useFeatureClient } from '@ctct/feature-sdk';

import type { ExperimentParams, ExperimentParamsProp } from './types';

type Experiment = ReturnType<ReturnType<typeof useFeatureClient>['getExperiment']>;

export function createExperimentData<T extends ExperimentParamsProp>(params: T, experiment: Experiment) {
  return Object.fromEntries(
    Object.entries(params).map(([key, defaultValue]) => {
      if (experiment.value[key] === undefined) {
        console.warn(`Value for ${key} not found in experiment ${experiment.name}`);
      }

      return [key, () => experiment.get(key, defaultValue)];
    })
  ) as ExperimentParams<T>;
}

export function createExperimentDataWithLocalValues<T extends ExperimentParamsProp>(params: T) {
  return Object.fromEntries(
    Object.entries(params).map(([key, defaultValue]) => {
      return [key, () => defaultValue];
    })
  ) as ExperimentParams<T>;
}

export enum CheckState {
  READY = 'ready',
  PRECONDITIONS_NOT_MET = 'preconditions_not_met',
  LOADING = 'loading',
  ERROR = 'error',
  TIMEOUT = 'timeout',
}

export const getCheckState = (
  preConditions: boolean | undefined,
  error: unknown,
  loading: boolean,
  isTimeout: boolean
): CheckState => {
  if (preConditions === false) return CheckState.PRECONDITIONS_NOT_MET;

  if (error) return CheckState.ERROR;

  if (loading && !isTimeout) return CheckState.LOADING;

  if (isTimeout) return CheckState.TIMEOUT;

  return CheckState.READY;
};
